import React from 'react';
import PropTypes from 'prop-types';
import Bugsnag from '@bugsnag/js';

// A widget that throws while rendering drops out instead of taking the app down,
// and tries again once the layout hands it a new config
class HomeWidgetErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false, config: props.config };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  static getDerivedStateFromProps(props, state) {
    return props.config === state.config ? null : { failed: false, config: props.config };
  }

  componentDidCatch(error, info) {
    if (Bugsnag.isStarted()) {
      Bugsnag.notify(error, (event) => {
        const { type } = this.props;
        event.addMetadata('widget', { type, componentStack: info.componentStack });
      });
    }
  }

  render() {
    const { failed } = this.state;
    const { children } = this.props;

    return failed ? null : children;
  }
}

HomeWidgetErrorBoundary.propTypes = {
  type: PropTypes.string,
  config: PropTypes.object,
  children: PropTypes.node,
};

export default HomeWidgetErrorBoundary;
